/**
 * Utility to find error objects by key name which can be a simple string
 * or a nested expression string
 *
 * @param errors = object with react hook form errors
 * @param key = string with field name like:
 * fieldName
 * fieldName.key
 * fieldName[0].key
 * @returns returns current error object if the field name is found in errors
 */
const getErrorByKeyName = (errors: Record<string, any>, key: string) => {
  const keys = key.split(/[\.\[\]]/);
  let currentObject: any = errors;

  for (const key of keys) {
    if (key !== "") {
      if (
        currentObject?.hasOwnProperty(key) ||
        (Array.isArray(currentObject) && !isNaN(Number(key)))
      ) {
        currentObject = currentObject[key];
      } else {
        return undefined;
      }
    }
  }

  return currentObject;
};

export default getErrorByKeyName;
